type Branded<T, B> = T & { readonly __brand: B };

export type PlayerId = Branded<string, "PlayerId">;
export type ActivityId = Branded<string, "ActivityId">;
export type MatchId = Branded<string, "MatchId">;
export type MatchResultId = Branded<string, "MatchResultId">;
export type BetId = Branded<string, "BetId">;

export const toPlayerId = (id: string): PlayerId => id as PlayerId;

export const toActivityId = (id: string): ActivityId => id as ActivityId;

export const toMatchId = (id: string): MatchId => id as MatchId;

export const toMatchResultId = (id: string): MatchResultId => id as MatchResultId;

export const toBetId = (id: string): BetId => id as BetId;
